var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionsTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 18.5h5v-5h-5v5Zm6.5 0h1.75A3.25 3.25 0 0 0 18 15.25V13.5h-5v5Zm5-6.5V7h-5v5h5Zm0-6.5V3.75A3.25 3.25 0 0 0 14.75.5H13v5h5Zm-6.5-5h-5v5h5v-5ZM5 .5H3.25A3.25 3.25 0 0 0 0 3.75V5.5h5v-5ZM0 7v5h5V7H0Zm0 6.5v1.75a3.25 3.25 0 0 0 3.25 3.25H5v-5H0ZM11.5 7v5h-5V7h5Z",
    fill: "#E9E9EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionsTable);
export default __webpack_public_path__ + "static/media/connections-table.85217ce14e3fc9925496bbeecc4c8845.svg";
export { ForwardRef as ReactComponent };